import { render } from "./AsContainer.vue?vue&type=template&id=393a630b&scoped=true&ts=true"
import script from "./AsContainer.vue?vue&type=script&lang=ts"
export * from "./AsContainer.vue?vue&type=script&lang=ts"

import "./AsContainer.vue?vue&type=style&index=0&id=393a630b&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393a630b"]])

export default __exports__